import { ReactComponent as LogoutBtn } from "assets/img/icons/logoutBtn.svg";
import { FC } from "react";
import HeaderConnect from "app/widgets/crypto-header/header-connect";
import { useAccount, useDisconnect } from "wagmi";
import Button from "../button/button";
import ThemeSwitcher from "../theme-switcher/theme-switcher";

import { shortAddress } from "app/utils/shortAddress";
import styles from "./dashboard-header.module.scss";

const DashboardHeader: FC = () => {
  const { address } = useAccount();
  const { disconnect } = useDisconnect();

  return (
    <header className={styles.header}>
      <div className={styles.user}>
        {address && (
          <>
            <Button variant="pink" className={styles.address}>
              {" "}
              {shortAddress(address)}
            </Button>
            <Button
              variant="pink"
              className={styles.logoutBtn}
              onClick={() => disconnect()}
            >
              <LogoutBtn />
            </Button>
          </>
        )}
        <div className={styles.connect}>
          <HeaderConnect />
        </div>
        <ThemeSwitcher />
      </div>
    </header>
  );
};

export default DashboardHeader;
